import React from 'react';
import './StageIndicator.css';

const StageIndicator = ({ currentStage, totalStages = 3 }) => {
  const stages = Array.from({ length: totalStages }, (_, i) => i + 1);

  return (
    <div className="stage-indicator">
      {stages.map((stage, index) => (
        <React.Fragment key={stage}>
          <div
            className={`stage-indicator__stage ${
              stage === currentStage
                ? 'stage-indicator__stage--active'
                : stage < currentStage
                ? 'stage-indicator__stage--completed'
                : 'stage-indicator__stage--upcoming'
            }`}
          >
            <span className="stage-indicator__label">Stage {stage}</span>
            <div className="stage-indicator__bar" />
          </div>
          {index < stages.length - 1 && (
            <div className="stage-indicator__separator">•</div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StageIndicator;
